module.exports = __webpack_public_path__ + "static/media/lock-blue.8315be3c.svg";